export const GET_CURRENT_DAILY_CHALLENGE_PREVIEW =
  'dailyChallenge/GET_CURRENT_DAILY_CHALLENGE_PREVIEW';
